"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESubtitleOffset = void 0;
exports.SubtitleLayout = SubtitleLayout;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./SubtitleLayout.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ContentLayout = require("../ContentLayout");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let ESubtitleOffset = exports.ESubtitleOffset = /*#__PURE__*/function (ESubtitleOffset) {
  ESubtitleOffset["XL"] = "xl";
  return ESubtitleOffset;
}({});
function SubtitleLayout(_ref) {
  let {
    children,
    offset
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)({
      [styles['container']]: true,
      [styles['container-padded']]: offset === ESubtitleOffset.XL
    })
  }, /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, children)));
}